<div class="flex items-center gap-1 border-b px-2 py-1 shadow-sm">
  <dt-workspace-selector></dt-workspace-selector>
  <span class="text-surface-300 text-lg">/</span>
  <dt-branch-selector></dt-branch-selector>
  <div class="grow"></div>

  <dt-undo-redo-buttons></dt-undo-redo-buttons>
  <!-- TODO[feature]: uncomment once history UI is production ready (better UI, diffing between versions, thoroughly tested) -->
  <!-- <dt-history-button></dt-history-button>-->
</div>
